module.exports = __webpack_public_path__ + "fonts/d624b14.ttf";